import { render, staticRenderFns } from "./ShareRoutes.vue?vue&type=template&id=4c4663c9&scoped=true&"
import script from "./ShareRoutes.vue?vue&type=script&lang=js&"
export * from "./ShareRoutes.vue?vue&type=script&lang=js&"
import style0 from "./ShareRoutes.vue?vue&type=style&index=0&id=4c4663c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4663c9",
  null
  
)

export default component.exports